// routes/public.tsx
import { lazy } from 'react';
import { DASHBOARD, PASSWORD, STATISTIC, BALANCE } from './paths';

const DashBoardPage = lazy(() => import('../features/dashboard/DashBoardPage'));
const Balance = lazy(() => import('../features/dashboard/components/Balance'));
const Password = lazy(() => import('../features/dashboard/components/Password'));
const UserData = lazy(() => import('../features/dashboard/components/UserData'));
const UserStats = lazy(() => import('../features/dashboard/components/UserStats'));

export const protectedRoutes = [
  {
    path: DASHBOARD,
    element: <DashBoardPage />,
    children: [
      { index: true, element: <UserData /> },
      { path: PASSWORD, element: <Password /> },
      { path: STATISTIC, element: <UserStats /> },
      { path: BALANCE, element: <Balance /> },
    ],
  },
];
